<template>
  <div class="box-container">
    <div v-for="item in dataList" :key="item.id">
      <div v-if="item.unit_type === 1 && item.display_style === 0">
        <MixItemList :data="item.item"></MixItemList>
      </div>
      <div v-else-if="item.unit_type === 1 && item.display_style === 2">
        <MixItemListTwoColGoods :dataList="item.item"></MixItemListTwoColGoods>
      </div>
      <div v-else-if="item.unit_type === 2">
        <BannerList :bannerList="item.item"></BannerList>
      </div>
      <div v-else-if="item.unit_type === 10">
        <BookShelfIcon></BookShelfIcon>
      </div>
      <div v-else-if="item.unit_type === 11">
        <RightFloatIcon icon-name="shopcart" to="/cart"></RightFloatIcon>
      </div>
      <div v-else-if="item.unit_type === 12">
        <RightFloatIcon icon-name="dingdan" position="top" to="/order_list"></RightFloatIcon>
      </div>
    </div>
  </div>
</template>

<script>
  import MixItemListTwoColGoods from "./MixItemListTwoColGoods";
  import BannerList from "../common/BannerList";
  import MixItemList from "./MixItemList";
  import BookShelfIcon from "../common/BookShelfIcon";
  import RightFloatIcon from "../common/RightFloatIcon";

  export default {
    name: "GeneralDisplayBox",
    components: {
      RightFloatIcon,
      BookShelfIcon,
      MixItemList,
      BannerList,
      MixItemListTwoColGoods,
    },
    props: {
      dataList: {
        type: Array,
        default: () => []
      },
    },
    methods: {},
    computed: {}
  };
</script>

<style lang="scss" scoped>
  .tab-item {
  }
</style>

